import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, finalize, map } from "rxjs";
import { environment } from "src/environments/environment";
import { EMasterDataType } from "../domain/enums/master-data-type";
import { CoreData } from "../tools/core-data/core-data";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BaseService } from "./base.service";
import { LoadingTask } from "../tools/loading-task";

@Injectable({
    providedIn: 'root',
})
export class MasterDataService extends BaseService {

    private serviceUrl = `${environment.serviceBaseUrl}api/masterdata`;

    constructor(public http: HttpClient,
        protected override coreData: CoreData,
        protected snackBare: MatSnackBar,
        private loadingTask: LoadingTask,
        protected override router: Router) {

        super(router, coreData, snackBare);
    }

    getMyIntervention() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/allmeasurereferences`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('allmeasurereferences')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string[]) => {
                return response.map((item: string) => {
                    item;
                });
            }));
    }

    getMasterDataByType(masteDataType: EMasterDataType) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/ByType/${masteDataType}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getMasterDataByType')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string[]) => {
                return response.map((item: string) => {
                    return item;
                });
            }));
    }
}